module.exports = __webpack_public_path__ + "img/a8f76c50ab3556a12b4c1f1e0f46a0bd.png";